import { addDays } from "date-fns/addDays";
import { getWeeksInMonth } from "date-fns/getWeeksInMonth";
import type { CommonCalendarOptions } from "../types";

export interface MonthGridDay {
  date: Date;
  dayNumber: number;
  isOtherMonth: boolean;
  weekIndex: number;
  dayIndex: number;
}

export const getMonthGridDays = (
  startDate: Date,
  weekStart: CommonCalendarOptions["weekStart"] = "sunday"
): MonthGridDay[] => {
  const weekStartsOn = weekStart === "monday" ? 1 : 0;
  const offsetIntoWeek = (startDate.getDay() - weekStartsOn + 7) % 7;
  const firstCellDate = addDays(startDate, -offsetIntoWeek);
  const rowsOfDays = getWeeksInMonth(startDate, { weekStartsOn });

  return Array.from({ length: rowsOfDays }).flatMap((_, weekIndex) =>
    Array.from({ length: 7 }).map((_, dayIndex) => {
      const date = addDays(firstCellDate, weekIndex * 7 + dayIndex);

      return {
        date,
        dayNumber: date.getDate(),
        isOtherMonth: date.getMonth() !== startDate.getMonth(),
        weekIndex,
        dayIndex,
      };
    })
  );
};
